var progress = function progress(min, max, value) {
  return max - min === 0 ? 1 : (value - min) / (max - min);
};
export { progress };